import React from 'react';
import { Layout } from '../components/Layout';
export function TermsPage() {
  return <Layout data-id="element-619">
      <div className="py-24 px-6 bg-alabaster border-b-3 border-charcoal" data-id="element-620">
        <div className="max-w-7xl mx-auto" data-id="element-621">
          <h1 className="text-6xl md:text-8xl font-bold mb-8" data-id="element-622">
            Terms of <br data-id="element-623" />
            <span className="italic font-serif font-normal text-espresso" data-id="element-624">
              Service
            </span>
          </h1>
          <p className="text-xl text-charcoal/60 max-w-2xl leading-relaxed" data-id="element-625">
            Please read these terms carefully before using our services.
          </p>
        </div>
      </div>
      <section className="py-24 px-6 bg-white" data-id="element-626">
        <div className="max-w-4xl mx-auto prose prose-charcoal" data-id="element-627">
          <h2 className="text-3xl font-bold mb-6" data-id="element-628">1. Acceptance of Terms</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-629">
            By accessing and using the services provided by NK Refacers, you
            agree to be bound by these Terms of Service and all applicable laws
            and regulations.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-630">2. Scope of Services</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-631">
            NK Refacers provides kitchen cabinet refacing services, including
            consultation, material selection, and installation. Specific project
            details will be outlined in individual service contracts.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-632">3. Estimates and Pricing</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-633">
            All quotes provided via our website or in-home surveys are estimates
            based on the information available at the time. Final pricing is
            subject to a formal site inspection and signed agreement.
          </p>

          <h2 className="text-3xl font-bold mb-6" data-id="element-634">4. Intellectual Property</h2>
          <p className="mb-8 text-charcoal/70 leading-relaxed" data-id="element-635">
            All content on this website, including text, images, and logos, is
            the property of NK Refacers and is protected by copyright laws.
          </p>
        </div>
      </section>
    </Layout>;
}